import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ReactSlider from "react-slider";
import { useDispatch, useSelector } from "react-redux";
import { fetchDistricts } from "../../redux/districtsSlice";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import generateSlug from "./generateSlug";
import UrltoSlug from "./UrlToSlug";
import { Helmet } from "react-helmet";

const Banner = ({ category, handleQuery = "" }) => {
  const location = useLocation();
  const [underscoreValue, setUnderscoreValue] = useState(null);
  const [image, setImg] = useState();
  const [searchQuery, setSearchQuery] = useState([]);
  const [propertyType, setPropertyType] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [values, setValues] = useState([0, 50000000]);
  const [localityId, setlocalityId] = useState("1");
  const budgetRef = useRef(null);
  const searchBoxRef = useRef(null);
  const [commercialServiceQuery, setCommericalServiceQuery] = useState("buy");
  const [city, setCity] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const { districts, status, error1 } = useSelector((state) => state.districts);
  const hasFetched = useRef(false);
  const [metaDetail, setMetaDetail] = useState([]);
  const apiKey = "6095af4ca12142f8b0ddfff8bd689908";
  const navigate = useNavigate();
  const [isBudgetOpen, setIsBudgetOpen] = useState(false);
  const [formattedValue, setFormattedValue] = useState("");

  // Handle change for budget range selection input
  const handleChange = (newValues) => {
    const split = (newValues + " ").split(",");
    if (split.length >= 2) {
      function formatCurrency(value) {
        if (value >= 10000000) {
          return `₹${(value / 10000000).toFixed(2)}Cr`; // Crores
        } else if (value >= 100000) {
          return `₹${(value / 100000).toFixed(2)}L`; // Lakhs
        } else if (value >= 1000) {
          return `₹${(value / 1000).toFixed(2)}K`; // Thousands
        } else {
          return `₹${value}`; // Less than 1000
        }
      }
      if (parseInt(split[0]) === 49999999) {
        setFormattedValue(`${formatCurrency(split[0])} +`);
      } else {
        setFormattedValue(
          `${formatCurrency(split[0])} - ${formatCurrency(split[1])}`
        );
      }
    } else {
      alert("Invalid input format");
    }
    setValues(newValues);
  };

  const handleCommercialService = (e) => {
    setCommericalServiceQuery(e.target.value);
  };

  const toggleBudget = () => {
    setIsBudgetOpen(!isBudgetOpen);
  };

  // Handle the input change in the search bar
  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value); // Update the search query on input change
  };

  const handlePropertyType = (e) => {
    setPropertyType(e.target.value);
  };

  // Handle selection of a suggested item (locality, city, project, etc.)
  const handleSuggestionSelect = (suggestion) => {
    const title = {
      buy: "flats-for-sale-in-",
      home: "flats-for-sale-in-",
      rent: "flats-for-rent-in-",
      plot: "plots-for-sale-in-",
    };
    setSearchQuery(suggestion.name);
    setSuggestions([]);
    if (suggestion.category === "locality") {
      const cat = suggestion.id;
      const finalCategory =
        category === "plot" || category === "home" ? "buy" : category;
      const type = category === "commercial" ? commercialServiceQuery : "";
      const filter =
        category === "plot"
          ? localStorage.setItem("feature_clicked", "property_type:plot")
          : null;
      const text1 = `${finalCategory}/${finalCategory === "commercial" ? `${commercialServiceQuery}/` : ""
        }searches`;
      const text2 = `${suggestion?.property_location}-srlid-${cat}`;
      const extra = title[category];
      const url = `${text1}/${extra ?? "property-in-"}${UrltoSlug(text2)}`;

      navigate(`/${url}`, {
        state: {
          name: suggestion.name,
          service: category,
          type: type,
          filter: filter,
        },
      });
    } else if (suggestion.category === "city") {
      const cat = suggestion.id;
      const finalCategory =
        category === "plot" || category === "home" ? "buy" : category;
      const type = category === "commercial" ? commercialServiceQuery : "";
      const filter =
        category === "plot"
          ? localStorage.setItem("feature_clicked", "property_type:plot")
          : null;
      const text1 = `${finalCategory}/${finalCategory === "commercial" ? `${commercialServiceQuery}/` : ""
        }searches`;
      const text2 = `${suggestion?.property_location}-srcid-${cat}`;
      const extra = title[category];
      const url = `${text1}/${extra ?? "property-in-"}${UrltoSlug(text2)}`;
      navigate(`/${url}`, {
        state: {
          name: suggestion.name,
          service: category,
          type: type,
          filter: filter,
        },
      });
    } else if (suggestion.category === "sublocality") {
      const cat = suggestion.id;
      const finalCategory =
        category === "plot" || category === "home" ? "buy" : category; // Override 'plot' with 'buy'
      const type = category === "commercial" ? commercialServiceQuery : "";
      const filter =
        category === "plot"
          ? localStorage.setItem("feature_clicked", "property_type:plot")
          : null;
      const text1 = `${finalCategory}/${finalCategory === "commercial" ? `${commercialServiceQuery}/` : ""
        }searches`;
      const text2 = `${suggestion?.property_location}-srslid-${cat}`;
      const extra = title[category];
      const url = `${text1}/${extra ?? "property-in-"}${UrltoSlug(text2)}`;
      navigate(`/${url}`, {
        state: {
          name: suggestion.name,
          service: category,
          type: type,
          filter: filter,
        },
      });
    } else if (suggestion.category == "project") {
      const pid = suggestion?.id || "";
      const url = generateSlug(suggestion);
      window.location.href = url;
      localStorage.setItem(
        "last-property-seen",
        JSON.stringify({ id: pid, typeWithId: url })
      );
    }
  };

  // Fetch search suggestions from the API
  const fetchSuggestions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getLocalities?query=${searchQuery}&localityId=${localityId}`
      );
      setSuggestions(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  // Get a cookie by name
  const getCookie = (name) => {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
  };

  // Set a cookie for 7 days by default
  const setCookie = (name, value, days = 7) => {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; expires=${expires}; path=/`;
  };

  // Function: Get city name from lat/lon using OpenCage
  const getCityFromCoordinates = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lon}&key=${apiKey}`
      );
      const data = await response.json();

      const result = data?.results?.[0]?.components;
      const cityName =
        result?.state_district ||
        result?.city ||
        result?.town ||
        result?.village ||
        null;

      if (cityName) {
        setCity(cityName);
        setCookie("city", cityName);
      } else {
        setError("City not found");
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setError("Error fetching city name");
    }
  };

  const [property, setProperty] = useState({
    name: "manglam-aadhar",
    builder: "mangalam-bdl",
    location: "lalkothi",
    state: "jaipur-rajasthan",
    pid: 118673,
  });

  // Convert slug to readable title case
  function slugToTitle(slug) {
    if (!slug) return "";
    let cleanSlug = slug;
    cleanSlug = cleanSlug.replace(/_/g, "-");
    let words = cleanSlug.split("-").map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return words.join(" ");
  }

  // On mount: Get city from cookie or coordinates
  useEffect(() => {
    const cachedCity = getCookie("city");
    if (cachedCity) {
      setCity(cachedCity);
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          getCityFromCoordinates(latitude, longitude);
        },
        () => setError("Unable to retrieve your location.")
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  }, []);

  // Watch for property changes
  useEffect(() => {
    const finalCategory = category == "plot" ? "buy" : category;
    const type = category === "commercial" ? commercialServiceQuery : "";
  }, [property]);

  // Fetch districts if status is idle
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchDistricts());

      console.log("districts : : ", districts);
    }
  }, [dispatch, status]);
  let slug = "";
  // Get city slug based on location or underscoreValue
  useEffect(() => {
    const fetchCitySlug = async () => {
      if (hasFetched.current) return;
      let cityId = null;
      try {
        if (underscoreValue) {
          const cityResponse = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/get/city_by_slug`,
            { slug: underscoreValue, category }
          );
          if (cityResponse.data?.status == false) {
            console.warn("❌ City not found for slug:", underscoreValue);
            navigate("/not_found");
            return;
          } else {
            cityId = cityResponse.data?.city_id;
            const metaTag = cityResponse.data?.meta_tags;
            setMetaDetail(metaTag);
            let slugTitle = metaTag[0].url_slug || "";
            if (slugTitle) {
              window.history.replaceState({}, "", slugTitle);
            }
          }
        } else if (city && !underscoreValue) {
          const slugResponse = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/get/city_slug`,
            { city: city, category }
          );
          const citySlug = slugResponse.data?.city_slug;
          const metaTag = slugResponse.data?.meta_tags;
          setMetaDetail(slugResponse.data?.meta_tags);
          slug = metaTag[0].url_slug || "";
          if (citySlug) {
            const baseUrl = window.location.origin;
            const newUrl = `${baseUrl}/${category !== "home" ? category + "/" : ""
              }${slug}`;
            window.history.replaceState({}, "", newUrl);
            hasFetched.current = true;
          }
        }
      } catch (error) {
        console.error("❌ Error fetching city slug:", error);
      }
    };
    fetchCitySlug();
  }, [underscoreValue, city, category]);

  // Fetch banners for the selected category and cache them in cookies
  useEffect(() => {
    const cate = category == "home" ? "buy" : category;
    const fetchBanners = async () => {
      try {
        const cookieBanners = Cookies.get("banners");
        const storedBanners = cookieBanners ? JSON.parse(cookieBanners) : {};
        if (storedBanners[cate]) {
          console.log("Fetching banner from cookies");
          setImg({ backgroundImage: `url('${storedBanners[cate]}')` });
          return;
        }
        console.log("Fetching banner from API");
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/get/banners`,
          { category: cate }
        );
        if (response.data.status) {
          const background = response.data.data.image;
          const myStyle = { backgroundImage: `url('${background}')` };
          storedBanners[cate] = background;
          Cookies.set("banners", JSON.stringify(storedBanners), { expires: 7 }); // expires in 7 days
          setImg(myStyle);
        } else {
          console.warn("Banner image not found in the response.");
        }
        console.log("Response:", response.data);
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };
    fetchBanners();
    if (category === "commercial") {
      handleQuery("");
    }
  }, [category]);

  // Refresh commercial listing when service query changes
  useEffect(() => {
    if (category == "commercial") {
      handleQuery(commercialServiceQuery);
    }
  }, [category, commercialServiceQuery]);

  // Close dropdowns when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBoxRef.current &&
        !searchBoxRef.current.contains(event.target)
      ) {
        setSuggestions([]);
      }
      if (budgetRef.current && !budgetRef.current.contains(event.target)) {
        setIsBudgetOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Extract underscore value from URL (e.g. slug)
  useEffect(() => {
    const path = location.pathname;
    const pathSegments = path.split("/").filter(Boolean);
    if (pathSegments.length === 0) return;
    const lastSegment = pathSegments[pathSegments.length - 1];
    const lastPart = lastSegment.split("-").pop();
    if (lastPart.includes("_")) {
      setUnderscoreValue(lastPart);
      console.log("✅ Extracted:", lastPart);
    } else {
      console.log("❌ No underscore value found.");
    }
  }, [location.pathname]);

  // Trigger suggestion fetch when search query is long enough
  useEffect(() => {
    if (searchQuery.length > 2) {
      fetchSuggestions();
    } else {
      setSuggestions([]);
    }
  }, [searchQuery]);

  // alert(slug);

  return (
    <div>
      {/* Meta Details */}
      {/* <Helmet>
        <title>
          {metaDetail[0]?.category_id === "home"
            ? slugToTitle(metaDetail[0]?.meta_title)
            : slugToTitle(metaDetail[0]?.url_slug)}
        </title>
        <meta name="description" content={metaDetail[0]?.meta_description} />
        <meta name="keyword" content={metaDetail[0]?.meta_keyword} />
        <meta
          property="og:title"
          content={
            metaDetail[0]?.category_id === "home"
              ? slugToTitle(metaDetail[0]?.meta_title)
              : slugToTitle(metaDetail[0]?.url_slug)
          }
        />
      </Helmet> */}


      <Helmet>
        <title>
          {metaDetail?.[0]?.category_id === "home"
            ? slugToTitle(metaDetail?.[0]?.meta_title)
            : slugToTitle(metaDetail?.[0]?.url_slug)}
        </title>

        <meta name="description" content={metaDetail?.[0]?.meta_description || ''} />
        <meta name="keywords" content={metaDetail?.[0]?.meta_keyword || ''} />

        <meta
          property="og:title"
          content={
            metaDetail?.[0]?.category_id === "home"
              ? slugToTitle(metaDetail?.[0]?.meta_title)
              : slugToTitle(metaDetail?.[0]?.url_slug)
          }
        />
        <meta
          property="og:description"
          content={metaDetail?.[0]?.meta_description || ''}
        />
        <meta
          property="og:image"
          content={metaDetail?.[0]?.og_image || 'https://dreamsakha.rusofterp.in/public/webimage/setting/174591535068108dd6e4ebasid.png'}
        />
        <meta
          property="og:url"
          content={typeof window !== 'undefined' ? window.location.href : ''}
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* Banner */}
      <section className="homebanner">
        <div className="homebannerbox">
          <div
            className={
              category == "/"
                ? "banner-cover buy"
                : category == "rent"
                  ? "banner-cover rent"
                  : category == "plot"
                    ? "banner-cover plot"
                    : category == "commercial"
                      ? "banner-cover commercial"
                      : category == "living"
                        ? "banner-cover pg"
                        : "banner-cover base"
            }
            style={image ? image : []}
          >
              <div className="banner-overlay"></div>
            <div className="categorybox">
              <div className="catheads">
                <div
                  className={`cats buy cats_width ${
                    category === "buy" || category === "home"  ? `active_${category}` : ""
                  }`}
                >
                  {/* <a href="/buy/${slug}"> */}
                  <a href={`/buy/${slug}`}>
                    <div
                      className={`caticon desk ${
                        category === "buy" || category === "home"  ? `active_${category}` : ""
                      }`}
                    ></div>
                    <div
                      className={`catname ${
                        category === "buy" || category === "home"  ? `active_${category}` : ""
                      }`}
                    >
                      BUY
                    </div>
                  </a>
                </div>

                {/* <div
                  className={`cats rent ${
                    category === "rent" ? `active_${category}` : ""
                  }`}
                >
              
                  <a href={`/rent/${slug}`}>
                    <div
                      className={`caticon desk ${category === "rent" ? `active_${category}` : ""
                        }`}
                    ></div>
                    <div
                      className={`catname ${category === "rent" ? `active_${category}` : ""
                        }`}
                    >
                      RENT
                    </div>
                    </a>
                 
                </div> */}

                <div
                  className={`cats plot cats_width ${
                    category === "plot" ? `active_${category}` : ""
                  }`}
                >
                  <a href={`/plot/${slug}`}>
                    <div
                      className={`caticon desk ${category === "plot" ? `active_${category}` : ""
                        }`}
                    ></div>
                    <div
                      className={`catname ${category === "plot" ? `active_${category}` : ""
                        }`}
                    >
                      PLOTS
                    </div>
                  </a>
                </div>

                <div
                  className={`cats commercial cats_width ${
                    category === "commercial" ? `active_${category}` : ""
                  }`}
                >
                  {/* <Link to="/commercial"> */}
                  <a href={`/commercial/${slug}`}>
                    <div
                      className={`caticon desk ${category === "commercial" ? `active_${category}` : ""
                        }`}
                    ></div>
                    <div
                      className={`catname ${category === "commercial" ? `active_${category}` : ""
                        }`}
                    >
                      COMMERCIAL
                    </div>
                    {/* </Link> */}
                  </a>
                </div>

                {/* <div
                  className={`cats pg ${
                    category === "living" ? `active_${category}` : ""
                  }`}
                >
                
                  <a href={`/living/${slug}`}>
                    <div
                      className={`caticon desk ${category === "living" ? `active_${category}` : ""
                        }`}
                    ></div>
                    <div
                      className={`catname ${category === "living" ? `active_${category}` : ""
                        }`}
                    >
                      <span className="desk">PG/CO-LIVING</span>
                      <span className="mob">PG</span>
                    </div>
                 
                  </a>
                </div> */}
              </div>

              <div>
                <div className="homesearch">
                  {districts.length > 0 && (
                    <select
                      className=" form-control locationtxt desk"
                      id="select_city"
                      disabled={"true"}
                    >
                      <option value="" selected>
                        Jaipur
                      </option>
                      {districts.map((district, index) => (
                        <>
                          <option
                            key={index}
                            value={district.id}
                            selected={
                              city.toLowerCase() === district.name.toLowerCase()
                                ? "selected"
                                : ""
                            }
                          >
                            {district.name}
                          </option>
                        </>
                      ))}
                    </select>
                  )}

                  <div className="searchtxtbox" ref={searchBoxRef}>
                    <div style={{ display: "flex" }}>
                      <input
                        id="search_bar"
                        type="text"
                        className="form-control"
                        placeholder="Search for locality, landmark"
                        aria-label="Search for locality, landmark"
                        value={searchQuery}
                        onChange={(e) => handleSearchInputChange(e)}
                        onClick={() => fetchSuggestions()}
                        style={{ border: "none" }}
                      />
                      {category === "commercial" && (
                        <div className="commercial-service">
                          <input
                            id="buy"
                            type="radio"
                            name="commercial-service"
                            value="buy"
                            onChange={(e) => handleCommercialService(e)}
                            checked={commercialServiceQuery === "buy"}
                          />
                          <label htmlFor="buy">Buy</label>

                          <input
                            id="lease"
                            type="radio"
                            name="commercial-service"
                            value="lease"
                            onChange={(e) => handleCommercialService(e)}
                            checked={commercialServiceQuery === "lease"}
                          />
                          <label htmlFor="lease">Lease</label>
                        </div>
                      )}
                    </div>
                    {suggestions.length > 0 && (
                      <ul className="suggestions-list">
                        {suggestions.map((suggestion, index) => (
                          <li
                            key={index}
                            onClick={() => handleSuggestionSelect(suggestion)}
                          >
                            <span
                              style={{ color: "#343434" }}
                              className="suggestion-name"
                            >
                              {suggestion.name ?? ""}
                            </span>
                            <span
                              style={{ color: "lightgrey" }}
                              className="suggestion-category"
                            >
                              {suggestion.category ?? "Locality"}
                            </span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                  <div className="select-box hidefornow">
                    <select
                      className=" propertytype"
                      id="propertytype"
                      onChange={handlePropertyType}
                    >
                      <option value="" selected>
                        Property Type-----
                      </option>
                      <option value="1bhk">1 BHK</option>
                      <option value="2bhk">2 BHK</option>
                      <option value="3bhk">3 BHK</option>
                      <option value="penthouse">Pent House</option>
                      <option value="villa">Villa</option>
                      <option value="flats">Flat/Apartment</option>
                    </select>
                  </div>

                  <div className="budgetouter hidefornow" ref={budgetRef}>
                    <div
                      htmlFor="budget"
                      className="form-select budgetsel"
                      onClick={toggleBudget}
                    >
                      <p>Budget {formattedValue}</p>
                    </div>

                    <div
                      className={`budgetbox ${isBudgetOpen ? "slide-down" : "d-none"
                        }`}
                    >
                      <input
                        className="budgetinput"
                        id="budget"
                        type="text"
                        value={`₹${values[0]} - ₹${values[1]}`}
                        readOnly
                      />
                      <ReactSlider
                        className="horizontal-slider"
                        thumbClassName="thumb"
                        trackClassName="track"
                        value={values}
                        onChange={handleChange}
                        min={0}
                        max={50000000}
                        pearling
                        minDistance={1}
                        renderThumb={(props) => <div {...props}></div>}
                      />
                    </div>
                  </div>

                  <button
                    onClick={() =>
                      handleSuggestionSelect({
                        id: 1,
                        name: "Jaipur",
                        location: "1",
                        developer: "",
                        category: "city",
                        property_location: "Jaipur-Rajasthan",
                      })
                    }
                    className="btn searchbtn base"
                    type="button"
                  >
                    <span className="search">Search</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Banner;
